module.exports = __webpack_public_path__ + "media/images/stars-07055ae3.jpg";